module.exports = __webpack_public_path__ + "static/media/Guqin Qi.a280c189.png";